import {colors} from '../../styles'
import {css} from 'glamor'

export const style = {
  activeButton: css({
    color: colors.white,
    border: 'none',
    borderRadius: '3px',
    background: colors.activeBG,
    '&:hover': {
      background: colors.activeHover
    }
  }),
  content: css({
    marginTop: '20px',
    marginBottom: '20px'
  }),
  error: css({
    color: colors.errorRed
  }),
  shadow: css({
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)'
  }),
  leftFormCol: css({
    paddingRight: '2px',
    '@media (max-width: 970px)': {
      paddingRight: '15px'
    }
  }),
  centerFormCol: css({
    paddingLeft: '2px',
    paddingRight: '2px',
    '@media (max-width: 970px)': {
      paddingLeft: '15px',
      paddingRight: '15px'
    }
  }),
  rightFormCol: css({
    paddingLeft: '2px',
    '@media (max-width: 970px)': {
      paddingLeft: '15px'
    }
  }),
  helpText: css({
    color: colors.helpText
  }),
  shrink: css({
    lineHeight: '18px',
    fontSize: '11px'
  }),
  titleHeader: css({
    marginTop: 0,
    marginBottom: 0,
    borderRadius: '5px 5px 0 0',
    background: colors.lightBG,
    color: colors.defaultText,
    padding: '7px 10px 4px',
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: 'inherit'
  }),
  success: css({
    color: colors.successText,
    fontWeight: '600'
  }),
  uppercaseText: css({
    textTransform: 'uppercase'
  }),
  defaultBottomBorder: css({
    borderBottom: `1px solid ${colors.defaultBorder}`
  }),
  orderSummary: css({
    fontSize: '13px',
    border: `1px solid ${colors.lightBG}`,
    borderWidth: '0 1px 1px',
    borderRadius: '0 0 5px 5px',
    paddingBottom: 0
  })
}

export const formStyle = {
  primaryAction: css({
    background: colors.actionOrange,
    color: colors.white,
    height: '50px',
    lineHeight: '24px',
    marginBottom: '40px',
    textTransform: 'uppercase',
    width: '100%'
  }),
  description: css({
    marginBottom: '30px'
  }),
  group: css({
    marginBottom: '20px'
  }),
  title: css({
    marginBottom: '12px'
  }),
  section: css({
    marginBottom: '28px'
  }),
  subtitle: css({
    marginBottom: '20px',
    textTransform: 'uppercase'
  })
}

export const fadeInOutStyle = {
  container: css({
    float: 'left',
    overflow: 'hidden',
    transition: 'opacity 250ms ease-in-out',
    width: '100%'
  }),
  entering: css({
    display: 'block',
    opacity: 0
  }),
  entered: css({
    display: 'block',
    opacity: 1
  }),
  exiting: css({
    display: 'block',
    opacity: 0
  }),
  exited: css({
    display: 'none',
    opacity: 0
  })
}

export const aspectRatio = (ratio, child = 'div', childStyle) => ({
  paddingTop: `${Math.round(ratio * 100)}%`,
  height: 0,
  position: 'relative',
  [`& > ${child}`]: {
    position: 'absolute',
    left: 0,
    right: 0,
    ...childStyle
  }
})
